var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 42,
    viewBox: "0 0 66 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_62)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_37_62",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 26,
    height: 34,
    rx: 3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 26,
    height: 34,
    rx: 3,
    stroke: "#5DEE7A",
    strokeWidth: 8,
    mask: "url(#path-1-inside-1_37_62)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_37_62",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 26,
    height: 34,
    rx: 3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 26,
    height: 34,
    rx: 3,
    stroke: "#5DEE7A",
    strokeWidth: 8,
    mask: "url(#path-2-inside-2_37_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7071 17.7071C52.0976 17.3166 52.0976 16.6834 51.7071 16.2929L45.3431 9.92893C44.9526 9.53841 44.3195 9.53841 43.9289 9.92893C43.5384 10.3195 43.5384 10.9526 43.9289 11.3431L49.5858 17L43.9289 22.6569C43.5384 23.0474 43.5384 23.6805 43.9289 24.0711C44.3195 24.4616 44.9526 24.4616 45.3431 24.0711L51.7071 17.7071ZM15 17V18H51V17V16H15V17Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_62",
    x: 0,
    y: 0,
    width: 66,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_62",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchGreen);
export default __webpack_public_path__ + "static/media/match-green.7fb62eade2e43db3b8c5d14e3899674c.svg";
export { ForwardRef as ReactComponent };